import { $ } from "@/common/Axios";

export default {
  /**
   * 家庭作业
   */
  homework: {
    /*
     * 添加
     * homeworkDate 作业日期 (string query )
     * id  (integer query )
     * name 作业名称 (string query )
     * teacherId 教师id (integer query )
     * teachingPlanId 教学计划id (integer query )
     */
    post: (p, c) => $.post("/api/zms/content/homework", p, c),

    /*
     * 删除
     * id 内容id (integer query required)
     */
    delete: (p, c) => $.delete("/api/zms/content/homework", p, c),
  },
  homework_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/zms/content/homework/export", p, c),
  },
  homework_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/zms/content/homework/list", p, c),
  },
  homework_listSimple: {
    /*
     * 简易列表
     * teachingPlanId 教学计划id (integer query required)
     */
    get: (p, c) => $.get("/api/zms/content/homework/listSimple", p, c),
  },

  /**
   * 职教通学校内容
   */
  siteContent: {
    /*
     * 添加
     * ableStatus 启用禁用 (string query )
     * content 内容 (string query )
     * contentType 内容类型：图片、视频 (string query )
     * id  (integer query )
     * label 标签 (string query )
     * positionType 位置类型：轮播，列表 (string query )
     * publishTime 发布时间 (string query )
     * siteId 学校id (integer query )
     * title 标题 (string query )
     * type 类型：学生风采 (string query )
     */
    post: (p, c) => $.post("/api/zms/content/siteContent", p, c),

    /*
     * 删除
     * id 内容id (integer query required)
     */
    delete: (p, c) => $.delete("/api/zms/content/siteContent", p, c),
  },
  siteContent_listStudentStyle: {
    /*
     * 学生风采列表
     */
    get: (p, c) => $.get("/api/zms/content/siteContent/listStudentStyle", p, c),
  },
  siteContent_listStudentStyleBannerForClient: {
    /*
     * 学生风采轮播图列表
     * phone 手机号，家长的时候填写 (string query )
     * type 类型：学生、家长 (string query required)
     */
    get: (p, c) =>
      $.get(
        "/api/zms/content/siteContent/listStudentStyleBannerForClient",
        p,
        c
      ),
  },
  siteContent_listStudentStyleForClient: {
    /*
     * 学生风采列表
     * phone 手机号，家长的时候填写 (string query )
     * type 类型：学生、家长 (string query required)
     */
    get: (p, c) =>
      $.get("/api/zms/content/siteContent/listStudentStyleForClient", p, c),
  },

  /**
   * 职教通学校内容点赞
   */
  siteContentLike: {
    /*
     * 点赞|取消
     * contentId 内容id (integer query required)
     * phone 手机号，家长的时候填写 (string query )
     * type 类型：学生、家长 (string query required)
     */
    post: (p, c) => $.post("/api/zms/content/siteContentLike", p, c),
  },

  /**
   * 学生家庭作业
   */
  studentHomework: {
    /*
     * 编辑
     * homeworkId 作业id (integer query )
     * id  (integer query )
     * schoolRollId 合同id (integer query )
     * status 是否已完成 (string query )
     */
    put: (p, c) => $.put("/api/zms/content/studentHomework", p, c),
  },
  studentHomework_downloadModule: {
    /*
     * 下载模板
     */
    get: (p, c) =>
      $.get("/api/zms/content/studentHomework/downloadModule", p, c),
  },
  studentHomework_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/zms/content/studentHomework/export", p, c),
  },
  studentHomework_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/zms/content/studentHomework/list", p, c),
  },
  studentHomework_upload: {
    /*
     * 批量导入
     * excelFile excelFile (file formData required)
     * homeworkId 作业id (integer query required)
     */
    post: (p, c) => $.post("/api/zms/content/studentHomework/upload", p, c),
  },

  /**
   * 学生就业记录
   */
  studentJobRecord: {
    /*
     * 添加
     * company 入职企业 (string query )
     * id  (integer query )
     * internshipSalary 实习薪资 (integer query )
     * jobDate 就业日期 (string query )
     * jobPosition 入职职位 (string query )
     * jobWay 就业方式 (string query )
     * latestStatus 是否最近 (string query )
     * offerId offer资源文件id (integer query )
     * regularSalary 转正薪资 (integer query )
     * remark 备注 (string query )
     * schoolRollId 合同id (integer query )
     */
    post: (p, c) => $.post("/api/zms/content/studentJobRecord", p, c),
  },
  studentJobRecord_listClassJob: {
    /*
     * 班级就业情况列表
     */
    get: (p, c) =>
      $.get("/api/zms/content/studentJobRecord/listClassJob", p, c),
  },
  studentJobRecord_listClassJobByDomain: {
    /*
     * 班级就业情况列表
     */
    get: (p, c) =>
      $.get("/api/zms/content/studentJobRecord/listClassJobByDomain", p, c),
  },
  studentJobRecord_listRecord: {
    /*
     * 学生就业记录列表
     * schoolRollId 合同id (integer query required)
     */
    get: (p, c) => $.get("/api/zms/content/studentJobRecord/listRecord", p, c),
  },
  studentJobRecord_listStudentJob: {
    /*
     * 学生就业情况列表
     * classRoomId 班级id (integer query required)
     * name 姓名 (string query )
     */
    get: (p, c) =>
      $.get("/api/zms/content/studentJobRecord/listStudentJob", p, c),
  },
  studentJobRecord_remark: {
    /*
     * 备注
     * id 记录id (integer query required)
     * remark 备注 (string query required)
     */
    put: (p, c) => $.put("/api/zms/content/studentJobRecord/remark", p, c),
  },
};
